<div class="card">
  <div class="label">{{ label | translate }}</div>
  <div class="value-row">
    <div *ngIf="value == null" class="lds-ring">
      <div></div>
    </div>
    
    <div *ngIf="value != null" class="value">
      <ng-container *ngIf="value2 != null; else onlyValue1">
        {{ value | number }}/{{ value2 | number }}
      </ng-container>
      <ng-template #onlyValue1>
        {{ value | number }}
      </ng-template>
    </div>

    <div class="control">
      <button
        class="dropdown-btn"
        [class.visible]="showDropdown && !showToggle"
        (click)="onDropdownToggle()"
        *ngIf="showDropdown"
      >
        <img
          src="../../../assets/icons/ng_v3/dropdown-icon.svg"
          alt="dropdown icon"
        />
      </button>
      <label
        class="toggle-switch"
        [class.visible]="showToggle"
        *ngIf="showToggle"
      >
        <input
          type="checkbox"
          [checked]="toggleValue"
          (change)="onToggleChange($event)"
        />
        <span class="slider"></span>
      </label>
    </div>
  </div>
  <ng-container *ngIf="isDropdownOpen && dropdownItems.length != 0">
    <div class="dropdown-content">
      <div *ngFor="let item of dropdownItems" class="dropdown-item">
        <div class="dropdown-label">{{ item.label }}</div>
        <div class="dropdown-value">{{ item.value | number }}</div>
      </div>
    </div>
  </ng-container>
</div>
